module.exports = __webpack_public_path__ + "static/img/AgAABXq0GNf8seHd3VhIbp4hyBS_B3dy.c2a243b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/帽子/AgAABXq0GNf8seHd3VhIbp4hyBS_B3dy.jpeg
// module id = f05d
// module chunks = 0